import type { ReactElement } from "react";
import { useEffect } from "react";
import { useLocation, useMatches, useNavigate } from "react-router-dom";

import { useAuthStore } from "@stores/authStore";

import PathContants from "./pathConstants";

type RouteHandle =
	| {
			requiresAuth?: boolean;
	  }
	| undefined;

export default function AuthGuard({ children }: { children: ReactElement }) {
	const { isLogin } = useAuthStore(["isLogin"]);

	const location = useLocation();
	const matches = useMatches();
	const navigate = useNavigate();
	useEffect(() => {
		if (matches.some(({ handle }) => (handle as RouteHandle)?.requiresAuth) && !isLogin) {
			navigate(`${PathContants.Login}?redirectTo=${location.pathname}`, {
				replace: true,
			});
		}
	}, [matches]);

	return children;
}
